import React, { useState } from 'react'
import { GridStyle, designTabBoxProps } from '../../../../../../styles/muiProps';
import { designInputs } from './FieldsData/DesignTabFields';
import { CustomSelect } from '../../../../../../components/widgets/CustomSelect';
import CustomTextField from '../../../../../../components/widgets/CustomTextField';
import { Box, Grid, InputAdornment, Typography } from '@mui/material';
import { getEdgeMentorTrace } from '../../edgeMentorTrace';
import DesignFieldMentorCard from '../../DesignFieldMentorCard';

const HeadingInputsGrid = () => {
    const [mentor, setMentor] = useState({ open: false, title: '', shownIn: [] });

    const handleFieldClick = (elem) => {
        const trace = getEdgeMentorTrace(elem.name);
        if (!trace) return;

        setMentor({
            open: true,
            title: `${trace.label} — where this value is shown`,
            shownIn: trace.shown_in || [],
        });
    };

    return (
        <>
            <Grid item xs={2} sm={2.6} md={3} lg={3} xl={2.6} >
                {/* Design Inputs Box */}
                <Box
                    {...designTabBoxProps}
                    noValidate
                >
                    {
                        designInputs.map(elem => (
                            <Grid key={elem.name} id="inner-container" item container
                                columns={12}
                            >
                                <Grid item sx={{ ...GridStyle }} xs={6}>
                                    <Typography fontSize={"0.75rem"}>{elem.label}</Typography>
                                </Grid>
                                < Grid item sx={{ ...GridStyle }} xs={6}>
                                    {
                                        elem.select ?
                                            <CustomSelect label="" name={elem.name} required
                                                menuItems={elem.select}
                                                onClick={() => handleFieldClick(elem)}
                                            /> :
                                            <CustomTextField label="" id={elem.name} name={elem.name} type={elem.type} pairField={elem.pairField}
                                                inputProps={{ endAdornment: <InputAdornment disableTypography sx={{ fontSize: "0.65rem", color: "black", fontFamily: "Roboto" }} position="end">{elem.endAdornment}</InputAdornment> }}
                                                onClick={() => handleFieldClick(elem)}
                                            />
                                    }
                                </Grid>
                            </Grid>
                        ))
                    }
                </Box>
            </Grid>

            {mentor.open && (
                <DesignFieldMentorCard
                    title={mentor.title}
                    shownIn={mentor.shownIn}
                    onClose={() => setMentor({ open: false, title: '', shownIn: [] })}
                />
            )}
        </>
    )
}

export default HeadingInputsGrid